import { Authorization, AuthorizationViewModel } from "api/authorization";

/**
 * Creates authorization view model
 * @param payload
 */
export const buildAuthorizationModel = ({
    ad,
    // eslint-disable-next-line @typescript-eslint/camelcase
    admaterial_lax,
    matspec,
    userrol,
    token,
    userid,
    username,
}: Authorization): AuthorizationViewModel => {
    return {
        ad,
        token,
        adMaterialLax: admaterial_lax,
        matSpec: matspec,
        userRole: userrol,
        userId: userid,
        user: username,
        isInternalUser: userrol !== "CLIENT",
    };
};
